export default __webpack_public_path__ + "static/media/Grips of the Masquer of the Sands.d191cdd3.jpg";